import React, { useState } from "react";
import { joinCommaValues, splitCommaValues } from "./businessFilterPayload";
import SettingsChipInput from "./SettingsChipInput";

/**
 * Inline chip input for comma-separated email/domain/keyword values.
 *
 * @example
 * CommaTagInput({
 *   value: "zoom.us, no-reply@zoom.us",
 *   onChange: () => {},
 *   placeholder: "+ Add sender…",
 * })
 */
const CommaTagInput = ({
  value,
  onChange,
  placeholder = "+ Add…",
}) => {
  const [draftValue, setDraftValue] = useState("");
  const values = splitCommaValues(value);

  const addItems = (rawValue) => {
    const incoming = splitCommaValues(rawValue);
    if (incoming.length === 0) {
      setDraftValue("");
      return;
    }
    const deduplicated = [...new Set([...values, ...incoming])];
    onChange(joinCommaValues(deduplicated));
    setDraftValue("");
  };

  const removeItem = (itemToRemove) => {
    onChange(joinCommaValues(values.filter((item) => item !== itemToRemove)));
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === ",") {
      event.preventDefault();
      addItems(draftValue);
      return;
    }
    if (event.key === "Backspace" && !draftValue && values.length > 0) {
      removeItem(values[values.length - 1]);
    }
  };

  const handleBlur = () => {
    if (draftValue.trim()) {
      addItems(draftValue);
    }
  };

  return (
    <div className="settings-row__chips">
      {values.map((item) => (
        <span key={item} className="settings-chip">
          <span className="settings-chip__text" title={item}>
            {item}
          </span>
          <button
            type="button"
            className="settings-chip__remove"
            onClick={() => removeItem(item)}
            aria-label={`Remove ${item}`}
          >
            ×
          </button>
        </span>
      ))}
      <SettingsChipInput
        value={draftValue}
        onChange={(event) => setDraftValue(event.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        placeholder={placeholder}
      />
    </div>
  );
};

export default CommaTagInput;
